import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "../services/constants";
import { showToastNotification } from "./toast";
import { setUsersInProject } from "../reducers/projectUsers";
import {
  setProjectRolesList,
  setSpacesInProjectList,
  setEntityListAction as setEntityList,
  setCategoryListAction as setCategoryList,
  setStatusData,
  deletedSpaceStatus,
  deletedUserStatus,
  getProjectSettingObjectAction as getProjectSettingObject,
} from "../reducers/projectSetting";

export { setUsersInProject };
export {
  setProjectRolesList,
  setSpacesInProjectList,
  setEntityList,
  setCategoryList,
  setStatusData,
  deletedSpaceStatus,
  deletedUserStatus,
  getProjectSettingObject,
};

// updateProjectRolePermission
export function updateProjectRolePermission(data) {
  return () => {
    axiosWrapper.post(`${getBackendUrl()}/projects/changeProjectRolePermission`, data);
  };
}

export function getProjectRoles(data) {
  return (dispatch) => {
    let projectId = data?.projectId;
    if (!projectId) {
      const pathArray = location.pathname.split("/");
      projectId = pathArray[pathArray.length - 2];
    }
    axiosWrapper
      .post(`${getBackendUrl()}/projects/getProjectRoles`, {
        id: projectId,
      })
      .then((response) => {
        if (response.data.status) {
          dispatch(setProjectRolesList(response.data.data));
        }
      });
  };
}

export function getUsersInSpaces(data) {
  return (dispatch) => {
    axiosWrapper.post(`${getBackendUrl()}/spaces/getSpaceUsersList`, data).then((response) => {
      dispatch(setSpacesInProjectList(response.data.result));
    });
  };
}

export function saveProjectRole(data, toastdata) {
  return (dispatch) => {
    axiosWrapper.post(`${getBackendUrl()}/projects/changeUserRoleFromProject/`, data).then((response) => {
      if (response.data.status) {
        dispatch(
          showToastNotification({
            content: `${toastdata.selectedUserfromRow}'s role has been changed to ${toastdata.roleChangedTo}`,
            type: TOAST_TYPE_SUCCESS,
          }),
        );
      } else {
        dispatch(
          showToastNotification({
            content: response.data.errorMessage,
            type: TOAST_TYPE_ERROR,
          }),
        );
      }
    });
  };
}
// updateStatusSpaces
export function updateStatusSpaces(data) {
  return () => {
    axiosWrapper.post(`${getBackendUrl()}/status/editVisibleData`, data);
  };
}
// getAllEntity
export function getAllEntity() {
  return (dispatch) => {
    axiosWrapper.get(`${getBackendUrl()}/status/getEntityList`).then((response) => {
      if (response.data.status) {
        dispatch(setEntityList(response.data.data));
      }
    });
  };
}
// addStatusToProject
export function addStatusToProject(data) {
  return () => {
    axiosWrapper.post(`${getBackendUrl()}/status/saveStatusData`, data);
  };
}
// getStatusData
export function getStatusData(data) {
  return (dispatch) => {
    axiosWrapper.post(`${getBackendUrl()}/status/getStatusData`, data).then((response) => {
      if (response.data.status) {
        dispatch(setStatusData(response.data.data));
      }
    });
  };
}
// getAllCategories
export function getAllCategories() {
  return (dispatch) => {
    axiosWrapper.get(`${getBackendUrl()}/status/getCategoryData`).then((response) => {
      if (response.data.status) {
        dispatch(setCategoryList(response.data.data));
      }
    });
  };
}
// get list of user which are added into project

// export function deleteSpace(data) {
//   return async (dispatch) => {
//     const response = await axiosWrapper.post(
//       `${getBackendUrl()}/spaces/deleteSpacesData`,
//       data
//     );

//     dispatch(deletedSpaceStatus(response.data.data));
//     return response.data.data.status;
//   };
// }

// delete space from project
export function deleteSpace(data) {
  return (dispatch) => {
    axiosWrapper.post(`${getBackendUrl()}/spaces/deleteSpacesData`, data).then((response) => {
      dispatch(deletedSpaceStatus(response.data.data));
    });
  };
}

// Delete User from a project

export async function removeUsersFromSingleProject(data) {
  const response = await axiosWrapper.post(`${getBackendUrl()}/projects/removeUsersFromSingleProject/`, data);
  return response.data;
}

export function getProjectObject(data) {
  if (data.id) {
    return (dispatch) => {
      axiosWrapper
        .get(`${getBackendUrl()}/projects/getProjectObject/${data.id}`)
        .then((res) => {
          if (res.data.status) {
            dispatch(getProjectSettingObject(res.data.data));
          }
        })
        .catch((err) => console.log("Error in project setting object ", err));
    };
  }
}
export const teamsController = async (data) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/projects/teamsController`, data);
  return response;
};
export const locationController = async (data) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/projects/locationController`, data);
  return response;
};
export const projectTemplateConfigHandler = async (data) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/forms/projectTemplateConfigHandler`, data);
  return response;
};
export const WBSController = async (data) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/projects/WBSController`, data);
  return response;
};
export const saveDefaultSpace = async (data) => {
  return await axiosWrapper.post(`${getBackendUrl()}/spaces/saveDefaultSpace`, data);
};
